import * as generalConstants from "../constants/event";
import { errorToast } from "../helpers/AlertHelper";

const initialState = {
  loading: false,
  projectCate: [],
  newsCate: [],
  sliders: [],
  projects: [],
  news: [],
  projectId: null,
  newsId: null,
  pages: 0,
  newsDetail: {},
  aboutUs: "",
  sharedList: [],
  displaySearch: false,
  generalContent: {},
  detailShared: {},
  keySearch: '',
  searchContent: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case generalConstants.SHOW_LOADING: {
      return {
        ...state,
        loading: true
      };
    }
    case generalConstants.HIDE_LOADING: {
      return {
        ...state,
        loading: false
      };
    }

    case generalConstants.FETCH_PROJECT_CATE: {
      return { ...state };
    }
    case generalConstants.FETCH_PROJECT_CATE_SUCCESS: {
      const { data } = action.payload;
      let dataFiltered = data
        .filter(item => item.status === "1")
        .map(item => {
          item.cateParent = "project";
          return item;
        });

      const item8 = dataFiltered.filter(item => item.id === 8);
      const allData = dataFiltered.filter(item => item.id !== 8);
      dataFiltered = [...item8, ...allData];

      return {
        ...state,
        projectCate: dataFiltered
      };
    }
    case generalConstants.FETCH_PROJECT_CATE_FAILED: {
      const { error } = action.payload;
      if (error.message === "Network Error") {
        errorToast("Vui lòng kiểm tra lại kết nối Internet", "top-right");
      } else {
        errorToast("Không lấy được danh mục con của Dự án", "top-right");
      }
      return { ...state };
    }

    case generalConstants.FETCH_NEWS_CATE: {
      return { ...state };
    }
    case generalConstants.FETCH_NEWS_CATE_SUCCESS: {
      const { data } = action.payload;
      const dataFiltered = data
        .filter(item => item.status === "1")
        .map(item => {
          item.cateParent = "news";
          return item;
        });

      return {
        ...state,
        newsCate: dataFiltered
      };
    }
    case generalConstants.FETCH_NEWS_CATE_FAILED: {
      const { error } = action.payload;
      if (error.message === "Network Error") {
        errorToast("Vui lòng kiểm tra lại kết nối Internet", "top-right");
      } else {
        errorToast("Không lấy được danh mục con của Tin tức", "top-right");
      }
      return { ...state };
    }

    case generalConstants.FETCH_SLIDER: {
      return { ...state };
    }
    case generalConstants.FETCH_SLIDER_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        sliders: data
      };
    }
    case generalConstants.FETCH_SLIDER_FAILED: {
      const { error } = action.payload;
      if (error.message === "Network Error") {
        errorToast("Vui lòng kiểm tra lại kết nối Internet", "top-right");
      } else {
        errorToast("Không lấy được slider, vui lòng thử lại", "top-right");
      }
      return { ...state };
    }

    case generalConstants.FETCH_PROJECT_BY_ID: {
      const { id } = action.payload.params;
      if (id === state.projectId) {
        return { ...state, projectId: id };
      } else {
        return { ...state, projectId: id, projects: [] };
      }
    }
    case generalConstants.FETCH_PROJECT_BY_ID_SUCCESS: {
      const { data, last_page, current_page } = action.payload.data;
      let dataNew = [];
      if (state.currentPage !== current_page) {
        dataNew = [...state.projects, ...data];
      } else {
        dataNew = data;
      }
      dataNew = dataNew.filter(
        (thing, index, self) => index === self.findIndex(t => t.id === thing.id)
      );

      return {
        ...state,
        projects: dataNew,
        pages: last_page,
        currentPage: current_page
      };
    }
    case generalConstants.FETCH_PROJECT_BY_ID_FAILED: {
      const { error } = action.payload;
      if (error.message === "Network Error") {
        errorToast("Vui lòng kiểm tra lại kết nối Internet", "top-right");
      } else {
        errorToast("Không lấy được dự án, vui lòng thử lại", "top-right");
      }
      return { ...state };
    }

    case generalConstants.FETCH_ALL_PROJECT: {
      if (state.projectId === "all") {
        return { ...state, projectId: "all" };
      } else {
        return { ...state, projectId: "all", projects: [] };
      }
    }
    case generalConstants.FETCH_ALL_PROJECT_SUCCESS: {
      const { data, last_page, current_page } = action.payload.data;
      let dataNew = [];
      if (state.currentPage !== current_page) {
        dataNew = [...state.projects, ...data];
      } else {
        dataNew = data;
      }
      dataNew = dataNew.filter(
        (thing, index, self) => index === self.findIndex(t => t.id === thing.id)
      );

      return {
        ...state,
        projects: dataNew,
        pages: last_page,
        currentPage: current_page
      };
    }
    case generalConstants.FETCH_ALL_PROJECT_FAILED: {
      const { error } = action.payload;
      if (error.message === "Network Error") {
        errorToast("Vui lòng kiểm tra lại kết nối Internet", "top-right");
      } else {
        errorToast("Không lấy được dự án, vui lòng thử lại", "top-right");
      }
      return { ...state };
    }

    case generalConstants.FETCH_NEWS: {
      if (state.newsId === "all") {
        return { ...state, newsId: "all" };
      } else {
        return { ...state, newsId: "all", news: [], page: 1 };
      }
    }
    case generalConstants.FETCH_NEWS_SUCCESS: {
      const { data, last_page, current_page } = action.payload.data;
      let dataNew = [];
      if (state.currentPage !== current_page) {
        dataNew = [...state.news, ...data];
      } else {
        dataNew = data;
      }
      dataNew = dataNew.filter(
        (thing, index, self) => index === self.findIndex(t => t.id === thing.id)
      );

      return {
        ...state,
        news: dataNew,
        pages: last_page,
        currentPage: current_page
      };
    }
    case generalConstants.FETCH_NEWS_FAILED: {
      const { error } = action.payload;
      if (error.message === "Network Error") {
        errorToast("Vui lòng kiểm tra lại kết nối Internet", "top-right");
      } else {
        errorToast("Không lấy được tin tức, vui lòng thử lại", "top-right");
      }
      return { ...state };
    }

    case generalConstants.FETCH_NEWS_BY_ID: {
      const { id } = action.payload.params;
      if (id === state.newsId) {
        return { ...state, newsId: id };
      } else {
        return { ...state, newsId: id, news: [] };
      }
    }
    case generalConstants.FETCH_NEWS_BY_ID_SUCCESS: {
      const { data, last_page, current_page } = action.payload.data;
      let dataNew = [];
      if (state.currentPage !== current_page) {
        dataNew = [...state.news, ...data];
      } else {
        dataNew = data;
      }
      dataNew = dataNew.filter(
        (thing, index, self) => index === self.findIndex(t => t.id === thing.id)
      );

      return {
        ...state,
        news: dataNew,
        pages: last_page,
        currentPage: current_page
      };
    }
    case generalConstants.FETCH_NEWS_BY_ID_FAILED: {
      const { error } = action.payload;
      if (error.message === "Network Error") {
        errorToast("Vui lòng kiểm tra lại kết nối Internet", "top-right");
      } else {
        errorToast("Không lấy được dự án, vui lòng thử lại", "top-right");
      }
      return { ...state };
    }

    case generalConstants.FETCH_NEWS_CONTENT: {
      return { ...state };
    }
    case generalConstants.FETCH_NEWS_CONTENT_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        newsDetail: data
      };
    }
    case generalConstants.FETCH_NEWS_CONTENT_FAILED: {
      const { error } = action.payload;
      if (error.message === "Network Error") {
        errorToast("Vui lòng kiểm tra lại kết nối Internet", "top-right");
      } else {
        errorToast(
          "Không lấy được nội dung tin tức, vui lòng thử lại",
          "top-right"
        );
      }
      return { ...state };
    }

    case generalConstants.FETCH_ABOUT_US_CONTENT_SUCCESS: {
      const { data } = action.payload;

      return { ...state, aboutUs: data.content };
    }

    case generalConstants.FETCH_SHARED_LIST_SUCCESS: {
      const { data } = action.payload;
      
      return {...state, sharedList: data.data}
    }

    
    // -------------step 6---------------------
    case generalConstants.SET_DISPLAY_SEARCH: {
      return {...state, displaySearch: !state.displaySearch}
    }

    case generalConstants.SET_KEY_SEARCH: {
      const keyString = action.payload;
      return {...state, keySearch: keyString}
    }

    case generalConstants.FETCH_SEARCH: {
      return {
        ...state,
        searchContent: []
      }
    }

    case generalConstants.FETCH_SEARCH_SUCCESS:{
      const data = action.payload;
      return {...state, searchContent: data}
    }

    case generalConstants.FETCH_SEARCH_FAILED: {
      const { error } = action.payload;
      if (error.message === "Network Error") {
        errorToast("Vui lòng kiểm tra lại kết nối Internet", "top-right");
      } else {
        errorToast(
          "Không lấy được nội dung tin tức, vui lòng thử lại",
          "top-right"
        );
      }
      return { ...state };
    }
    // -----General--------------------------
    case generalConstants.FETCH_GENERAL_CONTENT: {
      return { ...state };
    }
    case generalConstants.FETCH_GENERAL_CONTENT_SUCCESS : {
      const { data } = action.payload;
      return { ...state, generalContent: data }
    }
    case generalConstants.FETCH_GENERAL_CONTENT_FAIL: {
      const { error } = action.payload;
      if (error.message === "Network Error") {
        errorToast("Vui lòng kiểm tra lại kết nối Internet", "top-right");
      } else {
        errorToast(
          "Không lấy được thông tin chung, vui lòng thử lại",
          "top-right"
        );
      }
      return { ...state };
    }

    // ========Detail shared===================
    case generalConstants.FETCH_DETAIL_SHARED: {
      return {...state};
    }

    case generalConstants.FETCH_DETAIL_SHARED_SUCCESS: {
      const { data } = action.payload;
      return { ...state, detailShared: data}
    }

    default: {
      return state;
    }

  }
};

export default reducer;
